module.exports = __webpack_public_path__ + "static/rewe_logo-7c4dc5446f2096fd9b2bfafe14a31251.svg";